import React from 'react';
import {
  DefaultTypeString,
  Renderer,
  TypeObject,
  TypeString,
  TypeArray,
  WEB_PROXY,
} from '@rsos/ellington';
import CustomAccordion from './CustomAccordion';
import {
  StyledCustomCard,
  CustomCardHeader,
  Title,
  Description,
} from './CustomRenderer.styles';
import DataCardErrorBoundary from './DataCardErrorBoundary';
import DataCardLocation from './DataCardLocation';
import { getAlertHeaderText } from './utils';

export const CustomCard = ({
  description = '',
  children,
  showDisclaimer,
  emergencyType = '',
  siteType = '',
  serviceProviderName = '',
}) => {
  const emergencyTypeDisplayName = emergencyType?.display_name;
  return (
    <StyledCustomCard>
      {(emergencyTypeDisplayName || siteType || description) && (
        <CustomCardHeader>
          <Title>{getAlertHeaderText(emergencyType, siteType)}</Title>
          <Description>{serviceProviderName}</Description>
          {showDisclaimer && <div>Disclaimer</div>}
        </CustomCardHeader>
      )}
      {children}
    </StyledCustomCard>
  );
};

const CustomEllingtonCard = props => {
  const {
    schema,
    children,
    showDisclaimer,
    siteType,
    emergencyType,
    serviceProviderName,
    location = { civic: {}, geodetic: {}, provided_location: '' },
    time,
  } = props;
  const { title, description } = schema;

  return (
    <CustomCard
      title={title}
      description={description}
      children={children}
      showDisclaimer={showDisclaimer}
      siteType={siteType}
      emergencyType={emergencyType}
      serviceProviderName={serviceProviderName}
      location={location}
      time={time}
    />
  );
};

const CustomRenderer = props => {
  const location = props.location;
  const time = props.time;
  const currentAdr = props.data;
  const incidentType = props.emergencyType?.name;
  return (
    <>
      <DataCardLocation location={location} time={time} />
      {currentAdr.map(data => {
        const body = data.body;
        const displaySchema = data.display_schema;
        return (
          <DataCardErrorBoundary key={data.payload_id}>
            <Renderer {...props} data={body} displaySchema={displaySchema}>
              <TypeObject render={CustomEllingtonCard} root />
              <TypeArray
                format="accordion"
                render={ownProps => (
                  <CustomAccordion {...ownProps} incidentType={incidentType} />
                )}
              />
              <TypeString
                format={WEB_PROXY}
                render={ownProps => <DefaultTypeString {...ownProps} />}
              />
            </Renderer>
          </DataCardErrorBoundary>
        );
      })}
    </>
  );
};

export default React.memo(CustomRenderer);
